module.exports = __webpack_public_path__ + "static/img/translate.ff9a3cb4.svg";